import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { IconsModule } from '@progress/kendo-angular-icons';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { ActionSheetItem, NavigationModule } from '@progress/kendo-angular-navigation';
import { TileLayoutComponent } from '../tile-layout/tile-layout.component';

@Component({
  selector: 'casi-content',
  standalone: true,
  imports: [
        CommonModule,
        LayoutModule,
        ButtonsModule,
        IndicatorsModule,
        RouterModule,
        IconsModule,
        NavigationModule,
        TileLayoutComponent
  ],
  templateUrl: './content.component.html',
  styleUrl: './content.component.scss'
})
export class ContentComponent {
  @Input() selectedItem!: string;
}
